import { Component, OnInit, Input, TemplateRef, ViewChild, OnDestroy, OnChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { PHBHPFeaturePackageConfigurationService } from '../ph-bhp-feature-package-configuration.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { TranslationKeys } from 'ph-bhp-localization';
import { CheckStorageService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/public_api';
import { map } from 'rxjs/operators';

@Component({
  selector: 'lib-ph-bhp-configure-check-comments',
  templateUrl: './ph-bhp-configure-check-comments.component.html',
  styleUrls: ['./ph-bhp-configure-check-comments.component.css']
})
export class PhBhpConfigureCheckCommentsComponent implements OnInit {
  subscription: Subscription;
  userSubscription: Subscription;
  gridData: any[] = [];
  fields: any[];
  institutionID: number;
  @Input() institutions: any;
  @Input() userData: any;
  itemChange: boolean = false;
  InstitutionsList: [any];
  modalRef: BsModalRef;
  searchText;
  @ViewChild('delmodal') delmodal: TemplateRef<any>;
  selectedInstitution
  deleteDataItem
  deleterowIndex
  pageInfo
  selected = 0;
  countryID
  userID
  roleID
  translationKeys: typeof TranslationKeys = TranslationKeys;

  wardModelGridEdit: any = new UntypedFormGroup({
    title: new UntypedFormControl('', Validators.compose([Validators.required, Validators.maxLength(60)])),
    description: new UntypedFormControl('', Validators.compose([Validators.required, Validators.maxLength(60)])),
  });

  mygroup = new UntypedFormGroup({
    selectedIns: new UntypedFormControl(this.selected)
  });

  @ViewChild('grid') grid: any;

  constructor(
    private service: PHBHPFeaturePackageConfigurationService,
    private layoutService: PHBHPLayoutPackageService,
    private modalService: BsModalService,
    public translate: TranslateService,
    public config: AppConfig,
    public checkStorageService: CheckStorageService,
  ) {}
  ngOnInit() {

    this.layoutService.showLoader = true;

    this.fields = [
      {
        'field': 'title',
        'title': 'CONFIGURE.CHECK_COMMENTS.TITLE',
        editTemplate: {
          type: 'text',
          maxLength: 256
        }
      },
      {
        'field': 'description',
        'title': 'CONFIGURE.CHECK_COMMENTS.DESCRIPTION',
        editTemplate: {
          type: 'text',
          maxLength: 256
        }
      }
    ];
    this.pageInfo = {
      items: 'CONFIGURE.COMMENTS',
      itemsPerPageLabel: 'CONFIGURE.PER_PAGE.COMMENTS'
    };

    this.institutionID = parseInt(localStorage.getItem('selectedInstitution'));

    this.checkStorageService.getQuickCommentsByInstitutionId(this.institutionID).pipe(
      map((response: any) =>
        response.map((item: any) => ({ ...item, selected: false }))
      )).subscribe({
        next: (quickComments: any) => {
          this.layoutService.showLoader = false;
          this.gridData = quickComments;
        },
        error: (err: any) => {
          this.layoutService.showLoader = false;
          console.log('Error:', err);
        }
      });
  }

  actionItems: any = [
    { name: 'CONFIGURE.EDIT', imgSrc: 'assets/ph-bhp-layout/svg/icon-edit.svg', isEdit: true },
    { name: 'LAYOUT_MODULE.DELETE', imgSrc: 'assets/ph-bhp-layout/svg/icon-delete.svg', onClick: (dataItem) => {this.openDeleteModal(this.delmodal, dataItem);} }
  ];

  handlerData({
    handler,
    formGroup,
    isNew,
    dataItem,
    rowIndex
  }): void {
    this.userData = this.config.userData;
    switch (handler) {
      case 'saveHandler':
        var userId = this.userData.userId;
        var quickComment: any = {};
        quickComment.title = dataItem.title;
        quickComment.description = dataItem.description;
        quickComment.institutionID = this.layoutService.institutionID;
        // SET correct countryId
        quickComment.countryID = 0;
        quickComment.isDeleted = false;
        //var quickComment = dataItem;
        if (isNew) {
          this.checkStorageService.postQuickComment(quickComment).subscribe((res: any) => {
            // this.layoutService.showSuccess(this.layoutService.translateText('CONFIGURE.MESSAGE_SUCCESSFULLY.ADDED.COMMENT'));
            this.ngOnInit();
          });
        } else if (!isNew) {
          quickComment.updatedBy = userId;
          this.checkStorageService.putQuickComment(this.gridData[rowIndex].id, quickComment).subscribe((res: any) => {
            this.gridData[rowIndex].commentName = quickComment.title;
            this.gridData[rowIndex].commentName = quickComment.description;
            // this.layoutService.showSuccess(this.layoutService.translateText('CONFIGURE.MESSAGE_SUCCESSFULLY.UPDATED.COMMENT'));
            this.ngOnInit();
          });

        }
        break;

      case 'removeHandler':
        // this.openDeleteModal(this.delmodal, dataItem);
        break;
    }
  }
  openDeleteModal(deletemodal: TemplateRef<any>, dataItem) {
    this.deleteDataItem = dataItem
    this.modalRef = this.modalService.show(deletemodal, Object.assign({}, {
      class: 'w-420'
    }))
  }
  delete() {
    var userId = this.config.userData.userId;
    this.checkStorageService.deleteQuickComment(this.deleteDataItem.id, userId).subscribe((res: any) => {
      var data: any[] = JSON.parse(JSON.stringify(this.gridData));
      let index = data.findIndex(x => x.id === this.deleteDataItem.id);
      data.splice(index, 1);
      this.gridData = data;
      this.ngOnInit();
    })
  }

  showInstitutionDropDown() {
    if (this.InstitutionsList) {
      if (this.InstitutionsList.length < 2) {
        return false;
      } else {
        return true;
      }
    }
  }
  getInstitutionName() {
    if (this.InstitutionsList) {
      return this.InstitutionsList[0].institution.institutionName;
    }
  }

  addNew() {
    if(!this.grid.isNew) {
      this.gridData.unshift({
        "id": 0,
        "title": "",
        "description": "",
        "institutionID": this.layoutService.institutionID,
        "countryID": 0,
        "isDeleted": false,
        "updatedBy": 0
      });

      this.grid.editRowIndex = 0;
      this.grid.editItem = {};
      this.grid.isNew = true;
      this.grid.changeValue(true, 0, 'isActive', 'check');
      this.grid.changeValue(true, 0, 'isActiveValue', 'check');
      this.grid.updateGrid();
    }
  }

}
